import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
`;

export const Modal = styled.div`
  background: #1e1e1e;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  border-radius: 10px;
  border: 1px solid #e6aa3a;
  box-shadow: 0 0 30px rgba(230, 170, 58, 0.2);
  display: flex;
  flex-direction: column;
  animation: ${fadeIn} 0.3s ease;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 20px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  &:hover {
    color: #e6aa3a;
  }
`;

export const Content = styled.div`
  padding: 20px;
  display: flex;
  gap: 20px;
  flex: 1;
  overflow-y: auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InfoSide = styled.div`
  flex: 1;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const InfoItem = styled.div`
  label {
    display: block;
    font-size: 12px;
    color: #888;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  p {
    margin: 0;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
  }
`;

export const PreviewSide = styled.div`
  flex: 2;
  background: #000;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const Footer = styled.div`
  padding: 15px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
`;

export const LinkButton = styled.a`
  background: #e6aa3a;
  color: #111;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 700;
  display: inline-block;
  transition: 0.2s;

  &:hover {
    background: #ffc300;
  }
`;
